import React from 'react'
import { useSelector } from 'react-redux'
import { useComponentLocale } from '../../hooks/useComponentLocale'

export function TableTrainerPot() {
	const { trace, activeQueryTraceIndex } = useSelector((state) => state.view)

	const getLocale = useComponentLocale()
	const potLocale = getLocale({ component: 'common', section: 'pot' })

	const getPot = () => {
		let pot = null
		for (let i = 0; i < trace.length; i += 1) {
			const el = trace[i]
			if (el.type === 'action') {
				if (activeQueryTraceIndex === i) {
					pot = el.pot
				}
				if (activeQueryTraceIndex === -1) {
					pot = el.pot
				}
			}
		}

		return pot
	}

	const currentPot = getPot()

	return (
		<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 70.8 20.7' width={70} height={22} x='42%' y={78}>
			<style>{` .st5{fill:#fff}`} </style>
			<text fill='#fff' fontSize='11px' fontWeight='200' x='50%' y='50%' dominantBaseline='middle' textAnchor='middle'>
				{potLocale}: {currentPot && currentPot.toFixed(2)}
			</text>
		</svg>
	)
}
